/*
  Collection toolbar behaviour.
  - the sort select submits as soon as it changes, so it behaves like a filter
  - the secondary action opens the product grid's own filter drawer
*/
document.addEventListener('change', (event) => {
  const select = event.target.closest('#BrandSortBy');
  if (!select) return;

  const form = select.closest('form');
  if (form) form.submit();
});

document.addEventListener('click', (event) => {
  if (event.target.closest('[data-brand-close-facets]')) {
    const openSummary = document.querySelector('.mobile-facets__disclosure[open] > summary');
    if (openSummary) {
      event.preventDefault();
      openSummary.click();
    }
    return;
  }

  const trigger = event.target.closest('[data-brand-open-facets]');
  if (!trigger) return;

  // Click Shopify's own summary rather than setting details.open: the slide-in
  // and focus trap live in its click handler, so forcing the attribute leaves
  // the panel translated off screen.
  const summary = document.querySelector('.mobile-facets__disclosure > summary');
  if (!summary) return;

  event.preventDefault();
  summary.click();
});
